import React, { useState } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { signInPath } from "../utils/uiPreference";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  Fade,
} from "@mui/material";
import Logo from "../assets/new_logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import Footer from "../pages/LandingPage/Footer";
import { PricingFlag } from "../config";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(8px)",
  boxShadow: "none",
  borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
}));

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (path) => {
    if (path.startsWith("/")) {
      // External route
      navigate(path);
    } else {
      // Anchor within landing page
      navigate("/landing");
      // Wait for navigation to complete then scroll
      setTimeout(() => {
        const element = document.getElementById(path);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
    handleMenuClose();
  };


  const mainMenuItems = [
    { label: "Product", path: "hero" },
    { label: "Features", path: "features" },
    ...(PricingFlag ? [{ label: "Pricing", path: "pricing" }] : []),
    { label: "Contact Us", path: "contact" },
    { label: "Demo", path: "/demo" },
    { label: "Instant Interview", path: "/instantInterview" },
  ];

  // Sign In — the new console is the default front door. Someone who deliberately switched
  // back to the old UI still gets the old login; everyone else gets /v1/signin.
  const signInItem = { label: "Sign In", path: signInPath() };

  return (
    <>
      <StyledAppBar position="fixed">
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Logo (Left) */}
          {/* Logo (Left) */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/landing">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <img
                  src={Logo}
                  alt="HireBest AI"
                  style={{
                    height: "40px",
                    width: "auto", 
                    maxWidth: "100%", 
                    objectFit: "contain", 
                    cursor: "pointer",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#475569",
                  }}
                >
                  Intelligent, Automated & Natural AI Interviewer
                </Typography>
              </Box>
            </Link>
          </Box>

          {/* Mobile Menu */}
          {isMobile ? (
            <Box>
              <IconButton
                edge="end"
                color="primary"
                aria-label="menu"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                TransitionComponent={Fade}
                sx={{ mt: 1 }}
              >
                {[...mainMenuItems, signInItem].map((item) => (
                  <MenuItem
                    key={item.label}
                    onClick={() => handleNavigation(item.path)}
                    sx={{
                      padding: "10px 20px",
                      fontSize: "16px",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                        color: "#1565c0",
                      },
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ) : (
            /* Desktop Layout */
            <>
              {/* Center Menu Items */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flex: 1,
                  marginLeft: "40px",
                  marginRight: "40px",
                }}
              >
                <Box sx={{ display: "flex", gap: 4 }}>
                  {mainMenuItems.map((item) => (
                    <Button
                      key={item.label}
                      onClick={() => handleNavigation(item.path)}
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#333",
                        borderRadius: "8px",
                        padding: "6px 12px",
                        transition: "all 0.3s",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                          color: "#1565c0",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
              </Box>

              {/* Sign In Button (Right) */}
              <Box>
                <Button
                  onClick={() => handleNavigation(signInItem.path)}
                  // variant="contained"
                  sx={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#4472c6",
                    borderRadius: "8px",
                    padding: "8px 18px",
                    transition: "all 0.3s",
                    "&:hover": { color: "#1565c0" },
                  }}
                >
                  {signInItem.label}
                </Button>
              </Box>
            </>
          )}
        </Toolbar>
      </StyledAppBar>
      <Toolbar />

      <main>
        <Outlet />
      </main>

      <Footer />
    </>
  );
};

export default Layout;
